function hasScriptAlreadyLoaded(externalSrc) {
  const scripts = document.getElementsByTagName('script')
  let containsScript = false
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i] && scripts[i].src && scripts[i].src.includes(externalSrc)) {
      containsScript = true
    }
  }
  return containsScript
}

function logTracking(logHeader, logMessage) {
  if (window.CONFIGS && window.CONFIGS.ENV && window.CONFIGS.ENV !== 'prod') {
    /* eslint-disable no-console */
    console.log(`${logHeader}:`, logMessage)
  }
}

function isBrowser() {
  return !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  )
}

module.exports = {
  hasScriptAlreadyLoaded,
  logTracking,
  isBrowser,
}
